import React from "react";
import { Pagination as BSPagination } from "react-bootstrap";
import { useTranslation } from "./hooks/useTranslation";
const DEFAULT_MAX_PAGES_DISPLAYED = 7;
export const Pagination = ({ totalRecords, limit, offset, setOffset, maxPagesDisplayed = DEFAULT_MAX_PAGES_DISPLAYED, id, disabled, dataId, dataTestId, }) => {
    const totalPages = Math.ceil(totalRecords / limit);
    const currentPage = Math.floor(offset / limit);
    const prevEnabled = currentPage > 0;
    const nextEnabled = currentPage < totalPages - 1;
    const displayPageRange = React.useMemo(() => {
        let firstPage = currentPage - Math.floor(maxPagesDisplayed / 2);
        let lastPage = currentPage + Math.ceil(maxPagesDisplayed / 2);
        if (firstPage < 0) {
            const adjustment = 0 - firstPage;
            firstPage += adjustment;
            lastPage += adjustment;
        }
        if (lastPage >= totalPages) {
            const adjustment = lastPage - totalPages;
            firstPage -= adjustment;
            lastPage -= adjustment;
            if (firstPage < 0)
                firstPage = 0;
        }
        return range(firstPage, lastPage);
    }, [currentPage, maxPagesDisplayed, totalPages]);
    const t = useTranslation();
    return (React.createElement("nav", { className: "pagination--container", id: id },
        React.createElement(BSPagination, null,
            React.createElement(BSPagination.First, { disabled: !prevEnabled || disabled, onClick: prevEnabled && !disabled ? () => setOffset(0) : undefined, id: id && `${id}__first`, "data-testid": dataTestId && `${dataTestId}__first`, "data-id": dataId && `${dataId}__first`, "aria-label": t(`Go to first page`), "aria-disabled": !prevEnabled || disabled }),
            React.createElement(BSPagination.Prev, { disabled: !prevEnabled || disabled, onClick: prevEnabled && !disabled
                    ? () => setOffset((currentPage - 1) * limit)
                    : undefined, id: id && `${id}__previous`, "data-testid": dataTestId && `${dataTestId}__previous`, "data-id": dataId && `${dataId}__previous`, "aria-label": t(`Go to previous page`), "aria-disabled": !prevEnabled || disabled }),
            displayPageRange.map((i) => {
                const pageNumber = i + 1;
                return (React.createElement(BSPagination.Item, { key: i, active: currentPage === i, onClick: !disabled ? () => setOffset(i * limit) : undefined, id: id && `${id}__item-${pageNumber}`, "data-testid": dataTestId && `${dataTestId}__item-${pageNumber}`, "data-id": dataId && `${dataId}__item-${pageNumber}`, disabled: disabled, "aria-label": t(`Go to page ${pageNumber}`), "aria-disabled": disabled }, pageNumber));
            }),
            React.createElement(BSPagination.Next, { disabled: !nextEnabled || disabled, onClick: nextEnabled && !disabled
                    ? () => setOffset((currentPage + 1) * limit)
                    : undefined, id: id && `${id}__next`, "data-testid": dataTestId && `${dataTestId}__next`, "data-id": dataId && `${dataId}__next`, "aria-label": t(`Go to next page`), "aria-disabled": !nextEnabled || disabled }),
            React.createElement(BSPagination.Last, { disabled: !nextEnabled || disabled, onClick: nextEnabled && !disabled
                    ? () => setOffset((totalPages - 1) * limit)
                    : undefined, id: id && `${id}__last`, "data-testid": dataTestId && `${dataTestId}__last`, "data-id": dataId && `${dataId}__last`, "aria-label": t(`Go to last page`), "aria-disabled": !nextEnabled || disabled }))));
};
const range = (start, stop) => Array.from(Array(stop - start).keys()).map((i) => i + start);
